import { render, staticRenderFns } from "./AdBanner.vue?vue&type=template&id=e85b5c48"
import script from "./AdBanner.vue?vue&type=script&lang=js"
export * from "./AdBanner.vue?vue&type=script&lang=js"
import style0 from "./AdBanner.vue?vue&type=style&index=0&id=e85b5c48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports